import styled from '@emotion/styled';

import { mypageSubPageContainerCss, mypageSubPageTitleCss } from '@/components/MyPage/shared/subPageStyles';

interface InputTextProps {
	type?: string;
}

export const Container = styled.div`
	max-width: ${(props) => props.theme.scale.contentMaxWidth};
	width: 100%;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	gap: 6rem;
	${mypageSubPageContainerCss}
`;
export const Title = styled.h2`
	color: #212529;
	font-size: ${(props) => props.theme.fontSize.size4xl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: ${(props) => props.theme.ui.lineHeight.heading};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	${mypageSubPageTitleCss}
`;
export const Content = styled.pre`
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: ${(props) => props.theme.ui.lineHeight.body};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	white-space: pre-wrap;
	word-break: break-word;
`;
export const PrimaryContentBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
`;
export const PrimaryContentTitle = styled.h3`
	font-size: ${(props) => props.theme.fontSize.sizeXl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: ${(props) => props.theme.ui.lineHeight.heading};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
`;
export const SecondaryContentBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
`;
export const SecondaryContent = styled.ol<InputTextProps>`
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
	padding: 1.2rem;
	background-color: #f8f9fa;
	color: #495057;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: ${(props) => props.theme.ui.lineHeight.body};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	list-style: none;
	counter-reset: list-counter;
	> li {
		counter-increment: list-counter;
		position: relative;
		padding-left: 1.5rem;
	}
	> li::before {
		content: counter(list-counter) '. ';
		position: absolute;
		left: 0;
		color: #495057;
	}
	ol[type='a'] {
		list-style-type: none;
		padding-left: 1.5rem;
		counter-reset: list-counter;
	}
	ol[type='a'] > li {
		counter-increment: list-counter;
	}
	ol[type='a'] > li::before {
		content: counter(list-counter, lower-alpha) '. ';
	}
`;
export const TertiaryContentBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.4rem;
`;
export const TertiaryContentTitle = styled.h5`
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: ${(props) => props.theme.ui.lineHeight.heading};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
`;
export const TertiaryContent = styled.div`
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: ${(props) => props.theme.ui.lineHeight.body};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
`;
